import { useState } from 'react';
import { Building2, LockKeyhole, Mail } from 'lucide-react';
import { Navigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { useAuth } from '../lib/auth';

export default function Login() {
  const { session } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  if (session) return <Navigate to="/" replace />;
  const submit = async (e: React.FormEvent) => {
    e.preventDefault(); setError(''); setBusy(true);
    const { error: authError } = await supabase.auth.signInWithPassword({ email, password });
    if (authError) setError(authError.message);
    setBusy(false);
  };
  return (
    <div className="login-page">
      <div className="login-visual">
        <div className="login-brand"><div className="brand-mark large">M</div><div><strong>MAGNA International</strong><span>Branch Expense & Accounting Management</span></div></div>
        <div className="login-copy"><span className="eyebrow">CENTRALIZED FINANCE CONTROL</span><h1>Every branch expense, advance and payment in one secure ledger.</h1><p>Built for Head Office and branch teams with approval controls, audit trails and consolidated financial reporting.</p></div>
        <div className="login-points"><span><Building2 size={18}/> Multi-branch accounting</span><span><LockKeyhole size={18}/> Role-based approvals</span></div>
      </div>
      <div className="login-panel">
        <form className="login-card" onSubmit={submit}>
          <div><span className="eyebrow">WELCOME BACK</span><h2>Sign in to continue</h2><p>Use your authorized MAGNA account.</p></div>
          {error && <div className="alert alert-error">{error}</div>}
          <label>Email address<div className="input-with-icon"><Mail size={18}/><input type="email" value={email} onChange={(e)=>setEmail(e.target.value)} required autoComplete="email" placeholder="name@magna.lk" /></div></label>
          <label>Password<div className="input-with-icon"><LockKeyhole size={18}/><input type="password" value={password} onChange={(e)=>setPassword(e.target.value)} required autoComplete="current-password" placeholder="••••••••" /></div></label>
          <button className="button primary large-button" disabled={busy}>{busy ? 'Signing in…' : 'Sign in'}</button>
          <small>Contact the Super Administrator if your account has not been assigned a system role.</small>
        </form>
      </div>
    </div>
  );
}
